import React from "react";
import SkeletonLoader from "../Shimmer";

const CmsShimmer = () => {
  return <SkeletonLoader type={"text"} count={15} width={100} />;
};

export default CmsShimmer;
